"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const RootButton_1 = __importDefault(require("../Button/RootButton"));
const StyledButtonBase = (0, styled_1.default)(RootButton_1.default)({
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    padding: '0px',
    minWidth: '44px',
    minHeight: '44px',
    boxShadow: '0 10px 24px 0 rgba(155, 165, 177, 0.2)'
}, ({ theme, size, variant }) => ({
    'backgroundColor': `${theme.palette.colors.white}`,
    'color': theme.palette.colors.coolGrey,
    'border': `solid 1px ${theme.palette.colors.columbiaBlue}`,
    '&:hover': {
        backgroundColor: theme.palette.colors.antiFlash,
        border: `solid 1px ${theme.palette.colors.pastelBlue}`
    },
    '&:active': {
        backgroundColor: `${theme.palette.colors.solitude1}`
    },
    ...(size === 'small' && {
        minWidth: '34px',
        minHeight: '34px',
        boxShadow: 'none'
    }),
    ...(size === 'large' && {
        minWidth: '53px',
        minHeight: '53px'
    }),
    ...(variant === 'extended' && {
        minWidth: size === 'small' ? '43px' : size === 'medium' ? '75px' : '90px',
        minHeight: '45px',
        borderRadius: '24px',
        padding: '0px 10px'
    })
}));
const StyledChildContainer = styled_1.default.div({
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '16px',
    minHeight: '16px'
}, ({ size, variant }) => ({
    ...(variant === 'extended' && {
        '*:first-of-type': {
            marginRight: size === 'small' ? '3px' : size === 'medium' ? '5px' : '7px'
        }
    })
}));
const FloatingActionButton = ({ size = 'medium', variant = 'circular', children, ...rest }) => {
    return ((0, jsx_runtime_1.jsx)(StyledButtonBase, { variant: variant, size: size, ...rest, children: (0, jsx_runtime_1.jsx)(StyledChildContainer, { variant: variant, size: size, children: children }) }));
};
exports.default = FloatingActionButton;
//# sourceMappingURL=index.js.map